var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMatch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83333 16H4.33333C3.44928 16 2.60143 15.6488 1.97631 15.0237C1.35119 14.3986 1 13.5507 1 12.6667V5.16667C1 4.28261 1.35119 3.43477 1.97631 2.80964C2.60143 2.18452 3.44928 1.83333 4.33333 1.83333H13.5C14.3841 1.83333 15.2319 2.18452 15.857 2.80964C16.4821 3.43477 16.8333 4.28261 16.8333 5.16667V7.66667M6 1V2.66667M11.8333 1V2.66667M1 6H16.8333M14.75 12.3692L13.5 13.6192",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4999 17.6667C15.8011 17.6667 17.6666 15.8012 17.6666 13.5C17.6666 11.1989 15.8011 9.33337 13.4999 9.33337C11.1987 9.33337 9.33325 11.1989 9.33325 13.5C9.33325 15.8012 11.1987 17.6667 13.4999 17.6667Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMatch);
export default __webpack_public_path__ + "static/media/ic_match.2eb1d040ef8b173836b2ed19b1ffea3d.svg";
export { ForwardRef as ReactComponent };